export enum PlatformType {
  Shopify = 'Shopify',
  Volusion = 'Volusion',
  BigCommerce = 'BigCommerce',
  Magento = 'Magento',
  Demandware = 'Demandware',
  ThreeDcart = 'ThreeDcart',
  Wix = 'Wix',
  BigCartel = 'BigCartel',
  SquareSpace = 'SquareSpace',
  LemonStand = 'LemonStand',
  Etsy = 'Etsy',
  XCart = 'XCart',
  WooCommerce = 'WooCommerce',
  Amazon = 'Amazon',
  eBay = 'eBay',
  BigCommerceInstaller = 'BigCommerceInstaller',
  Walmart = 'Walmart',
  QuickBooks = 'QuickBooks',
  SalesForce = 'SalesForce',
  ShipHero = 'ShipHero',
  SageAccounting = 'SageAccounting',
  Sage50 = 'Sage50',
  Sage100 = 'Sage100',
  Sage300 = 'Sage300',
  SageX3 = 'SageX3',
  PrestaShop = 'PrestaShop',
  OpenCart = 'OpenCart',
  Reverb = 'Reverb',
  GrouponGoods = 'GrouponGoods',
  Kickstarter = 'Kickstarter',
  ZenCart = 'ZenCart',
  CommerceHQ = 'CommerceHQ',
  AspDotNetStorefront = 'AspDotNetStorefront',
  Ecwid = 'Ecwid',
  Hybris = 'Hybris',
  LightSpeed = 'LightSpeed',
  Neto = 'Neto',
  Shopware = 'Shopware',
  Api2Cart = 'Api2Cart',
  MsSql = 'MsSql',
  Undefined = 'Undefined'
}

export interface EcommerceStore {
  id: number,
  name?: string,
  url?: string,
}

export interface EcommerceSettings {
  fulfillOrder: boolean,
  storeNotification: boolean,
  insurance: boolean,
  defaultStore?: EcommerceStore,
}

export interface SupportedIntegrationInputField {
  fieldId: string,
  displayText: string,
  required: boolean;
}

export interface SupportedIntegration {
  platformType: PlatformType,
  inputFields: SupportedIntegrationInputField[],
}

export interface AddStorePayloadInputField {
  fieldId: string,
  value?: string,
}

export interface AddStorePayload {
  platformType: PlatformType,
  inputFields: AddStorePayloadInputField[]
}
